import { render, staticRenderFns } from "./CapturePhoto.vue?vue&type=template&id=08e8de88"
import script from "./CapturePhoto.vue?vue&type=script&lang=js"
export * from "./CapturePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e8de88')) {
      api.createRecord('08e8de88', component.options)
    } else {
      api.reload('08e8de88', component.options)
    }
    module.hot.accept("./CapturePhoto.vue?vue&type=template&id=08e8de88", function () {
      api.rerender('08e8de88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CapturePhoto.vue"
export default component.exports